import { render, staticRenderFns } from "./deleteAdmin.vue?vue&type=template&id=1d641e08"
import script from "./deleteAdmin.vue?vue&type=script&lang=ts"
export * from "./deleteAdmin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports